import { render, staticRenderFns } from "./SuppliesList.vue?vue&type=template&id=3b4d9b2d"
import script from "./SuppliesList.vue?vue&type=script&lang=js"
export * from "./SuppliesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports